import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '../../utils/cn';
import { INPUT_BASE_CLASS, INPUT_ERROR_CLASS } from '../form/formControlStyles';

export type InputProps = InputHTMLAttributes<HTMLInputElement> & {
    hasError?: boolean;
};

const Input = forwardRef<HTMLInputElement, InputProps>(
    ({ hasError = false, className, type = 'text', ...props }, ref) => {
        return (
            <input
                ref={ref}
                type={type}
                className={cn(INPUT_BASE_CLASS, hasError && INPUT_ERROR_CLASS, className)}
                {...props}
            />
        );
    }
);

Input.displayName = 'Input';

export default Input;
